import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;




export const getProfile = async payload => {
  let obj = JSON.parse(localStorage.getItem("authUser"))
 // console.log("calling getProfile"+ obj)

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: `${obj}`,
    Accept: "application/json",
    'Cache-Control': 'no-cache',
  }

  return await axios.get(`${apiBaseUrl}/myprofile`, {
    headers,
  })
}

// CREATE USER API
export const createProfile = async formdata => {
  try{
  const apiToken = JSON.parse(localStorage.getItem("authUser")) 
  const headers = {
    "Access-Control-Allow-Origin": "*",
    // "Content-Type": "multipart/form-data",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  };
  const response = await axios.post(`${apiBaseUrl}/updateprofile`, formdata, {
    headers,
  });
  return response;
} catch (error) {
  console.error("Error adding profile photo:", error);
  throw error;
}
 
}
